// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d029308","453":"32734b96","455":"a434bcbd"}[chunkId] + ".chunk.js";
};